import React from 'react';
import Select from 'react-select';
import { Link, useNavigate } from 'react-router-dom';

function SignUp() {

  const navigate = useNavigate();

  const industry = [
    { value: 'VIJAY INC. MNCs', label: 'VIJAY INC. MNCs' },
    { value: 'TATA', label: 'TATA' },
    { value: 'GOODREJ.', label: 'GOODREJ.' }
  ]
  const country = [
    { value: 'india', label: 'india' },
    { value: 'china', label: 'china' },
    { value: 'nepal', label: 'nepal' }
  ]

  const onSubmitForm = () => {
    navigate('/login');
  }

  return (<>
    <div className="w-screen h-screen">
      <div className="xl:w-2/4 lg:w-2/4 md:w-2/4 float-left h-full fixed bg-no-repeat bg-center bg-SignUp bg-welcomeBackImg bg-lighterBlue"></div>
      <div className="xl:w-2/4 lg:w-2/4 md:w-2/4 float-left h-full  "></div>
      <div className=" xl:w-2/4 lg:w-2/4 md:w-2/4 max-md:w-100  float-left h-full md:h-screen flex justify-center content-center">

        <div className="xl:w-logins1 lg:w-logins1 md:w-logins1 max-md:w-logins1 float-left h-full"></div>

        <div className="xl:w-logins2 lg:w-logins2 md:w-logins2 max-md:w-[75%]  h-full md:h-screen ">
          <form onSubmit={onSubmitForm}>
            <div className="w-100 text-[2.12vw] max-md:text-[4.24vw] font-bold text-center pr-[12.5%] pt-[20.5%] mb-[9px]">Create Account</div>
            <div className=""><span className="text-[.995vw] max-md:text-[2vw] regular">First Name</span><br /> <input required className="input text-[.995vw] max-md:text-[2vw]" type='text' placeholder='Enter First Name'></input> </div>
            <div className="mt-[6.5%]"><span className="text-[.995vw] max-md:text-[2vw] regular">Last Name</span><br /> <input required className="input text-[.995vw] max-md:text-[2vw]" type='text' placeholder='Enter Last Name'></input> </div>
            <div className="mt-[4.87%]"><span className="text-[.995vw] max-md:text-[2vw] regular">Company Name</span><br /> <input required className="input text-[.995vw] max-md:text-[2vw]" type='text' placeholder='Enter Company Name'></input> </div>
            <div className="mt-[4.06%] "><span className="text-[.995vw] max-md:text-[2vw] regular">Company Industry</span><br />
              <Select required className='mt-[2%] text-[.995vw] max-md:text-[2vw]'
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    padding: '1.6% 0%',
                  }),
                }} placeholder='Select Company Industry'
                options={industry} />
            </div>
            <div className="mt-[4.06%]"><span className="text-[.995vw] max-md:text-[2vw] regular">Country</span><br />
              <Select placeholder='Select Country' required className='mt-[2%] text-[.995vw] max-md:text-[2vw]'
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    padding: '1.6% 0%',
                  }),
                }}
                options={country} />
            </div>
            <div className="mt-[4.9%]"><span className="text-[.995vw] max-md:text-[2vw] regular">Phone Name</span><br /> <input required className="input text-[.995vw] max-md:text-[2vw]" type='number' minLength={10} placeholder='Enter Phone'></input> </div>
            <div className="mt-[4%]"><span className="text-[.995vw] max-md:text-[2vw] regular">Email Address</span><br /> <input required className="input text-[.995vw] max-md:text-[2vw]" type='email' placeholder='Enter Email Address'></input> </div>
            <div className="mt-[4%]"><span className="text-[.995vw] max-md:text-[2vw] regular">Password</span><br /> <input required className="input text-[.995vw] max-md:text-[2vw]" type='password' placeholder='Create Password'></input> </div>
            <div className="mt-[4.9%] regular w-100 ">
              <div className='float-left checkbox w-[6%]'><input required id='regula-checkbox' type='checkbox'></input></div>
              <div className='text-[.995vw] max-md:text-[2vw] float-left w-[94%]'>I have read  and accept the <span className='forLink text-[.995vw] max-md:text-[2vw]'>Privacy Policy</span> <br /> and <span className='forLink text-[.995vw] max-md:text-[2vw]'>Terms of Service</span></div>
            </div>
            <div className=""><button className="semiBold text-[.995vw] max-md:text-[2vw] loginBtn">Signup</button></div>
            <div className="text-center pb-[56px] text-[.927vw] max-md:text-[1.84vw] mt-[4.5%]">Already have an account? <Link to='/login'><span className="text-mainColor hover:underline hover:cursor-pointer">Login</span></Link> </div>
          </form>
        </div>

        <div className="xl:w-logins1 lg:w-logins1 md:w-logins1 max-md:w-logins1 float-left "></div>
      </div>
    </div>
  </>)
}

export default SignUp